export function resetTrackingIdentity() {
  if (!global.analytics) return false

  global.analytics.reset()
}
